import { render, staticRenderFns } from "./TdWorkFlowButton.vue?vue&type=template&id=2c1c11af&"
import script from "./TdWorkFlowButton.vue?vue&type=script&lang=js&"
export * from "./TdWorkFlowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports